(() => {
  const initialise = (root = document) => root.querySelectorAll('[data-event-share]').forEach((element) => {
    if (element.dataset.ready) return;
    element.dataset.ready = 'true';
    const textField = element.querySelector('[data-share-text]');
    const linkField = element.querySelector('[data-share-link]');
    const status = element.querySelector('[data-share-status]');
    const details = element.querySelector('details');
    const narrative = () => textField.value.trim();
    const copy = async (field, message) => {
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(field.value.trim());
        status.textContent = message;
      } catch {
        details.open = true;
        field.focus();
        field.select();
        status.textContent = element.dataset.copyFailed;
      }
    };
    const linkButton = element.querySelector('[data-copy-link]');
    const textButton = element.querySelector('[data-copy-text]');
    linkButton.hidden = false;
    textButton.hidden = false;
    linkButton.addEventListener('click', () => copy(linkField, element.dataset.copiedLink));
    textButton.addEventListener('click', () => copy(textField, element.dataset.copiedText));
    const nativeButton = element.querySelector('[data-native-share]');
    if (typeof navigator.share === 'function') {
      nativeButton.hidden = false;
      nativeButton.addEventListener('click', async () => {
        status.textContent = '';
        try {
          const text = narrative().split("\n").slice(0, -2).join("\n").trim();
          await navigator.share({title: element.dataset.title, text, url: element.dataset.url});
        } catch (error) {
          if (error.name !== 'AbortError') status.textContent = element.dataset.shareFailed;
        }
      });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
